import React from "react";
import { Input } from "antd";

export const InputField = React.memo(
  ({ label, name, value, onChange, type, icon, placeholder }) => (
    <div className="w-full mb-4">
      <label className="input-label px-1 ">{label}</label>
      <Input
        name={name}
        value={value}
        onChange={onChange}
        type={type}
        placeholder={placeholder}
        suffix={icon}
        style={{
          border: "1px solid #ebedf3",
          borderRadius: "10px",
          padding: "10px",
        }}
        className="custom-input border-b"
      />
    </div>
  )
);
